//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var geolocation = new qq.maps.Geolocation("T7SBZ-OJTL3-2PU3S-YHABH-GYHJK-FVFXQ", "HFB-hui-yuan-duan");
export default{
	name: "store",
	data(){
    return{
      storeList: [
        {}
      ],
      sid: "",
      popup: false,
      name: "",
      tel: "",
      remark: "",
      catchLat: "",
      catchLng: "",
      addr: ""
		}
	},
  methods:{
    onScrollBottom(){

    },
    call(sid){
      // window.location.href = "tel://" + tel;
      this.$router.push({
        path: '/storedetail',
        query: {
          sid
        }
      })
    }
  },
  mounted(){
    // console.log(window.localStorage.getItem('token'))
    this.$HTTP.HttpPost("/member/rescue/getStoreList", {})
    .then((data)=>{
      this.storeList = data.data.data;
      // geolocation.getLocation(
      // (msg)=>{
      //   this.remark = msg.province + msg.city + msg.district + msg.addr;
      //   this.catchLat = msg.lat;
      //   this.catchLng = msg.lng;
      //   this.addr = msg.addr;
      //   let start = 0;
      //   let end = 0;
      //   let distance = 0;
      //   for(let i in this.storeList){
      //     start = new qq.maps.LatLng(this.catchLat, this.catchLng);
      //     end = new qq.maps.LatLng(this.storeList[i].latitude, this.storeList[i].longitude);
      //     distance = Math.round(qq.maps.geometry.spherical.computeDistanceBetween(start, end)*1)/1000;
      //     this.storeList[i].distance = distance;
      //   }
      // },
      // (msg)=>{
      //   this.$vux.toast.show({
      //     text: "定位失败 请打开定位刷新重试",
      //     type: "text",
      //     width: "80%",
      //     isShowMask: true
      //   })
      // });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/store.vue